import {
  BillingFrequency,
  billingFrequencySchema,
  CheckoutResult,
  CheckoutType,
  PaymentPlan,
} from '../models/checkout';

import { hasStrikethroughPrice } from './has-strikethrough-price';

export function getStrikethroughPrice({
  checkoutType,
  billingFrequency,
  paymentPlan,
  checkoutResult,
}: {
  checkoutType: CheckoutType;
  billingFrequency: BillingFrequency;
  paymentPlan: PaymentPlan;
  checkoutResult: CheckoutResult;
}) {
  if (checkoutType === 'individual') {
    if (billingFrequency === billingFrequencySchema.enum['4month']) {
      return hasStrikethroughPrice(paymentPlan.upfront_amount.original_amount, checkoutResult?.original_amount_4_months)
        ? checkoutResult.original_amount_4_months_display
        : null;
    }
    return null;
  }

  if (billingFrequency === billingFrequencySchema.enum.annually) {
    return hasStrikethroughPrice(paymentPlan.upfront_amount.original_amount, checkoutResult?.original_amount_per_year)
      ? checkoutResult.original_amount_per_year_display
      : null;
  }

  return null;
}
